import apiClient from '../core';
import type { SEOAnalysisResult, SiteSEOOverview, BlogSEOOverview } from '../../schemas/validation';

export const seoApi = {
  getSiteOverview: async (siteId: string): Promise<SiteSEOOverview> => {
    const response = await apiClient.get<SiteSEOOverview>(`/seo/sites/${siteId}/seo/overview`);
    return response.data;
  },

  getPageAnalysis: async (pageId: string): Promise<SEOAnalysisResult> => {
    const response = await apiClient.get<SEOAnalysisResult>(`/seo/pages/${pageId}/seo`);
    return response.data;
  },

  getAllPagesAnalysis: async (
    siteId: string
  ): Promise<{
    siteId: string;
    totalPages: number;
    pages: SEOAnalysisResult[];
  }> => {
    const response = await apiClient.get(`/seo/sites/${siteId}/seo/pages`);
    return response.data;
  },

  getBlogPostAnalysis: async (blogId: string, postId: string): Promise<SEOAnalysisResult> => {
    const response = await apiClient.get<SEOAnalysisResult>(
      `/seo/blogs/${blogId}/posts/${postId}/seo`
    );
    return response.data;
  },

  getBlogOverview: async (blogId: string): Promise<BlogSEOOverview> => {
    const response = await apiClient.get<BlogSEOOverview>(`/seo/blogs/${blogId}/seo/overview`);
    return response.data;
  },
};
